'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEB_SEARCH = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.metabase = metabase;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WEB_SEARCH = exports.WEB_SEARCH = 'WEB_SEARCH';

var ANALYTICS = 'ms/analytics/analytics';
var ANALYTICS_SUCCESS = 'ms/analytics/analytics_success';
var ANALYTICS_FAIL = 'ms/analytics/analytics_fail';

//Reducer
var initialState = {
  posting: false,
  posted: false,
  postError: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case ANALYTICS:
      return (0, _extends3.default)({}, state, {
        posting: true,
        posted: false,
        postError: null
      });

    case ANALYTICS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        posting: false,
        posted: true,
        postError: null
      });

    case ANALYTICS_FAIL:
      return (0, _extends3.default)({}, state, {
        posting: false,
        posted: false,
        postError: action.error
      });

    default:
      return state;
  }
}

function metabase(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var messageBody = (0, _extends3.default)({
    event: eventName,
    platform: 'web'
  }, data);

  return {
    types: [ANALYTICS, ANALYTICS_SUCCESS, ANALYTICS_FAIL],
    promise: function promise(client) {
      return client.post('stats://message', { data: messageBody });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/analytics.js
// module id = 981
// module chunks = 0